import icon from '@/presentation/assets/images/icons/eou-evidence-search.svg';
import type { CustomQueryParams } from '@/services/router-proxy/types';
import { type Manifest, type RouterConfig, type ToolConfig, PAGE_TYPE } from '@/types/manifest';

export const EOU_ROUTER_NAME = 'eou';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.TOOL,
    name: EOU_ROUTER_NAME,
    exclusiveRoutePath: '/eou',
    getComponent: () => import('./EouStart.vue'),
};

const toolConfig: ToolConfig = {
    tabIndex: 4,
    label: 'agentHeader.eou',
    icon,
    aclCheckPath: () => true,
};

export const manifest: Manifest = {
    ...routerConfig,
    ...toolConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /** Go to the Evidence of Use task entry page. */
        executeCommand(commandId: 'command:route:eou', params?: CustomQueryParams): void;
    }
}
